$('.block-history-card-timeline').each(function() {

    const cards = $(this).find('.block-history-card');
    let most_recent = null;

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {

                entry.target.classList.add('is-visible');

                if (most_recent) {
                    most_recent.classList.remove('is-most-recent');
                }

                entry.target.classList.add('is-most-recent');
                most_recent = entry.target;

                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.5,
    });

    cards.each(function() {
        observer.observe(this);
    });

});
